import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import FixedTab from '../../components/RouteTabs/FixedTab';
import RouteTabs from '../../components/RouteTabs/RouteTabs';
import Comment from './Comment/Comment';
import BannedUser from './Comment/BannedUser';
import Main from './Main';
import BlockedWordSettings from './Setting/BlockedWordSettings';
import { RouteNames } from '../config';

interface IProps {}

const Moderation = (props: IProps & RouteComponentProps): JSX.Element => {
  const path = RouteNames.Moderation;

  return (
    <RouteTabs path={path}>
      <FixedTab label="Filtered">
        <Main path={`${path}`} isShownReportedOnly={true} />
      </FixedTab>
      <FixedTab label="All" uri="all">
        <Main path={`${path}/all`} isShownReportedOnly={false} />
      </FixedTab>
      <FixedTab label="Banned User" uri="banned">
        <BannedUser isBannedUserMode={true} isShownReportedOnly={false} />
      </FixedTab>
      <FixedTab label="Settings" uri="settings">
        <BlockedWordSettings />
      </FixedTab>
    </RouteTabs>
  );
};

export default Moderation;
